import { css } from '@emotion/react';
import { colorsDarkCSSVariables } from '../../common/Colors';

const otherDark = css`
  --tooltip-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 0, 0, 0.3);
  --preheader-fallback-bg: #444444;
  --preheader-bg: rgba(255, 255, 255, 0.05);
`;

export const darkTheme = css`
  [data-theme='dark'] {
    ${colorsDarkCSSVariables};
    ${otherDark};
  }
`;
